import { Skeleton, SkeletonGroup } from '@/components/ui/Skeleton';

/** While the role and the qualification load: the outline of the steps and of the theme cards. */
export const ProfileSkeleton = () => (
  <SkeletonGroup label="Chargement du profil" className="space-y-5">
    <div className="flex items-center gap-3">
      <Skeleton className="h-9 w-28 rounded-full" />
      <Skeleton className="h-9 w-28 rounded-full" />
      <Skeleton className="h-9 w-24 rounded-full" />
    </div>
    <div className="grid grid-cols-[repeat(auto-fill,minmax(13rem,1fr))] gap-3">
      {Array.from({ length: 6 }, (_, index) => (
        <div key={index} className="flex min-h-[8.5rem] flex-col gap-2 rounded-xl border border-domino-cardBorder bg-domino-warm px-4 py-3">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="mt-auto h-3 w-16" />
        </div>
      ))}
    </div>
  </SkeletonGroup>
);
